// src/components/ui/ArrayInput.jsx
import React, { useState } from "react";
import {
  VStack,
  HStack,
  Input,
  Button,
  IconButton,
  Text,
  FormControl,
  FormLabel,
  useColorModeValue,
} from "@chakra-ui/react";
import { DeleteIcon, AddIcon } from "@chakra-ui/icons";

const ArrayInput = ({
  value = [],
  onChange,
  label,
  placeholder = "Add item",
}) => {
  const [inputValue, setInputValue] = useState("");

  const borderColor = useColorModeValue("#e2e2dd", "#3a3a3a");
  const itemBg = useColorModeValue("#f3f3f0", "#2a2a2a");
  const focusBorder = useColorModeValue("#1a1a1a", "#eaeaea");

  const handleAdd = () => {
    if (inputValue.trim()) {
      const newArray = [...value, inputValue.trim()];
      onChange(newArray);
      setInputValue("");
    }
  };

  const handleRemove = (index) => {
    const newArray = value.filter((_, i) => i !== index);
    onChange(newArray);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleAdd();
    }
  };

  return (
    <FormControl>
      {label && (
        <FormLabel fontSize="16px" fontWeight="bold" mb={2}>
          {label}
        </FormLabel>
      )}
      <VStack align="stretch" spacing={2}>
        <HStack spacing={2}>
          <Input
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder={placeholder}
            size="md"
            fontSize="16px"
            borderRadius="14px"
            _hover={{ borderColor: focusBorder }}
            _focus={{
              borderColor: focusBorder,
              boxShadow: `0 0 0 1px ${focusBorder}`,
            }}
          />
          <Button
            onClick={handleAdd}
            leftIcon={<AddIcon boxSize={3} />}
            size="sm"
            h="36px"
            fontSize="15px"
            variant="facebook"
            borderRadius="999px"
          >
            Add
          </Button>
        </HStack>

        {value.length > 0 && (
          <VStack align="stretch" spacing={1}>
            {value.map((item, index) => (
              <HStack
                key={index}
                px={2}
                py={1}
                bg={itemBg}
                borderRadius="14px"
                justify="space-between"
                border="1px solid"
                borderColor={borderColor}
              >
                <Text fontSize="16px" flex={1}>
                  {item}
                </Text>
                <IconButton
                  icon={<DeleteIcon boxSize={3} />}
                  size="sm"
                  h="24px"
                  bg="#ffebee"
                  color="#d32f2f"
                  variant="ghost"
                  onClick={() => handleRemove(index)}
                  aria-label="Remove item"
                  _hover={{ bg: "#ffcdd2" }}
                />
              </HStack>
            ))}
          </VStack>
        )}
      </VStack>
    </FormControl>
  );
};

export default ArrayInput;
